import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plrAddCommas' })
export class AddCommasPipe implements PipeTransform {
  transform(values: null | string[]) {
    if (!values) {
      return '';
    }

    switch (values.length) {
      case 0:
        return '';
      case 1:
        return values[0];
      case 2:
        return values.join(' and ');
      default:
        const last = values[values.length - 1];
        const remaining = values.slice(0, -1);
        return `${remaining.join(', ')}, and ${last}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/add-commas.pipe.ts